var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[(_vm.showBreadcrumbs === 'yes')?_vm._t("default"):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/PageHeader.vue?vue&type=template&id=79ac872a&scoped=true&
// module id = 211
// module chunks = 0